export enum TABLE_CONSTANTS {
	customPageSize = 10,
}

export enum CONTENT_TYPE {
	CSV = 'text/csv',
	JSON = 'application/json',
	MULTIPART = 'multipart/form-data',
	BLOB = 'arraybuffer',
}

export enum FILE_UPLOAD_STATUS {
	DATA_TRANSFORMATION_INITIATED = 'Data Transformation Initiated',
	DATA_TRANSFORMATION_COMPLETED = 'Data Transformation Completed',
	DATA_VALIDATION_INITIATED = 'Data Validation Initiated',
	DATA_VALIDATION_COMPLETED = 'Data Validation Completed',
	DATA_PERSISTENCE_INITIATED = 'Data Persistence Initiated',
	COMPLETED = 'Completed',
	FAILED = 'Failed',
}

export const REVIEW_STATUS = [
	{
		label: 'Unassigned',
		value: 'Unassigned',
	},
	{
		label: 'inprogress',
		value: 'In-Progress',
	},
	{
		label: 'Complete',
		value: 'Complete',
	},
];

export const MINIMUM_CHARACTER_MESSAGE =
	'Type Atleast 3 characters to show results';

export const NO_OPTIONS_MESSAGE = 'No Options Found';

export enum CLUSTER_RUN_STATUS {
	INPROGRESS = 'inprogress',
	COMPLETED = 'completed',
}

export enum PAGINATION_CONSTANTS {
	PAGE_SIZE = 10,
	PAGE_NUMBER = 0,
}

/// Size in MB
export const maxFileSizeAllowedInDataIngestion = 50;

export const readyAssessURL =
	'https://qa.readyassess.pwc.com/assessment-definitions/115338874/assessment-runs/550585934/profile';

export const PUBLIC_ROUTES = ['/', '/callback', '/unauthorized'];

export enum MODULES {
	HOME = 'Home Landing Page',
	MAPPING_ENGINE = 'Mapping Engine',
	DATA_INGESTION = 'Data Ingestion',
	REQUIREMENT_INVENTORY = 'Requirements Inventory',
	RISK_QUANTIFICATION = 'Risk Quantification',
	CHANGE_ENGINE = 'Change Engine',
	REGULATION_CHANGE = 'Regulation Change',
	RISK_CHANGE = 'Risk Change',
	AI_MODELS = 'AI Models',
	GRC = 'GRC',
	MODIFIED_CHANGES = 'Modified Changes',
	AI_SIMULATION_AND_EXPERIMENTATION = 'Simulation Arena',
	HORIZON_SCAN_AND_ALERTS = 'Horizon Scan and alerts',
	ASK_RISK_LINK = 'Ask Risk Link',
	RISK_REFERENCE_TAXONOMY = 'PRC Inventory',
	REPORTING_DATABASE = 'Reporting Database',
	TESTING_AND_MONITORING = 'Testing & Monitoring',
	MANAGEMENT = 'Management',
}

export enum MODULE_NAME {
	HORIZON_SCAN_NAME = 'Horizon change',
	REQUIREMENT_INVENTORY_NAME = 'Requirements inventory',
	RISK_REFERENCE_TAXONOMY_NAME = 'PRC Inventory',
}

export enum TASKTYPE {
	WORKFLOW = 'Workflow',
	TASK = 'Task',
}

export enum REG_CHANGE_STATUS {
	IN_PROGRESS = 'inprogress',
	IN_COMING = 'incoming',
	PAST_DUE = 'pastdue',
	COMPLETED = 'completed',
}

export enum IREQUIREMENTS_INVENTORY_DASHBOARD {
	IREQUIREMENT_TABS_BANNER = 'Browse from PwC’s massive curated library or custom library',
	IREQUIREMENT_GROUPING_CONTENT = 'Obligations can be managed and queried over the lifecycle of the regulatory or policy obligation',
}

export enum AI_SIMULATION_DASHBOARD {
	AI_SIMULATION_BANNER = 'Browse from AI recipes or AI models',
}

export enum SETTINGS_DASHBOARD {
	SETTINGS_BANNER_TITLE = 'Management',
	SETTINGS_BANNER_BODY = 'A control center for managing Risk Link’s operations and settings.',
}

export const allowedModules = [
	MODULES.MANAGEMENT,
	MODULES.AI_MODELS,
	MODULES.AI_SIMULATION_AND_EXPERIMENTATION,
	MODULES.ASK_RISK_LINK,
	MODULES.CHANGE_ENGINE,
	MODULES.DATA_INGESTION,
	MODULES.GRC,
	MODULES.HORIZON_SCAN_AND_ALERTS,
	MODULES.MAPPING_ENGINE,
	MODULES.MODIFIED_CHANGES,
	MODULES.REGULATION_CHANGE,
	MODULES.REPORTING_DATABASE,
	MODULES.REQUIREMENT_INVENTORY,
	MODULES.RISK_CHANGE,
	MODULES.RISK_QUANTIFICATION,
	MODULES.RISK_REFERENCE_TAXONOMY,
	MODULES.TESTING_AND_MONITORING,
];

export const ENABLE_BANNER_MODULES = [
	'/home',
	'/requirement-inventory',
	'/simulation-arena',
	'/reporting',
	'/horizon-scanning',
	'/management',
	'/data-ingestion',
	'/prc-inventory',
];

export enum BUTTON_LABELS {
	GET_STARTED = 'Get started',
	LATEST_UPDATES = 'Latest updates',
	CLEAR_ALL = 'Clear all',
	CANCEL = 'Cancel',
	SUBMIT = 'Submit',
	APPLY = 'Apply',
	DELETE = 'Delete',
	BACK = 'Back',
	UPLOAD_SUBMIT = 'Upload & Submit',
	NEXT = 'Next',
	UPLOAD = 'Upload',
	START_PROCESSING = 'Start processing',
}
export enum FILTER_LABELS {
	ADVANCED_FILTERS = 'Advanced filters',
}

export enum TOAST_SEVERITY {
	ERROR = 'error',
	INFO = 'info',
	SUCCESS = 'success',
	WARNING = 'warning',
}

export enum ToolbarType {
	SEARCH,
	SORT,
	FILTER,
	TOGGLE_VIEW,
}

export enum ViewType {
	GRID = 'GRID',
	TABLE = 'TABLE',
	CARD = 'CARD',
	HEATMAP = 'HEATMAP',
}

export const dashboardOverviewTools = [
	ToolbarType.SEARCH,
	ToolbarType.SORT,
	ToolbarType.FILTER,
	ToolbarType.TOGGLE_VIEW,
];

export enum TABLE_VIEW_PAGE_SIZE {
	TABLE_SIZE_5 = 5,
	TABLE_SIZE_10 = 10,
	TABLE_SIZE_12 = 12,
	TABLE_SIZE_24 = 24,
	TABLE_SIZE_25 = 25,
	TABLE_SIZE_48 = 48,
	TABLE_SIZE_50 = 50,
}

export enum GRID_VIEW_PAGE_SIZE {
	GRID_SIZE_10 = 10,
	GRID_SIZE_25 = 25,
	GRID_SIZE_50 = 50,
}
export enum SORT_ORDER {
	ASCENDING = 'asc',
	DESCENDING = 'desc',
}

export enum ADVANCED_FILTERS_SCROLL_THRESHOLD {
	THRESHOLD = 50,
}
export interface LinkType {
	label: string;
	link: string;
}

export enum APP_THEME {
	BLUE = 'theme-blue',
	ORANGE = 'theme-orange',
}

export const SORT_DIRECTION_ASC = 'asc';

export const RISK_LINK_LABEL = 'Risk Link';

export const oktaLogoutIdleTime = 1000 * 15 * 60;

export const azureLogoutIdleTime = 1000 * 15 * 60;

export const USER_NOT_FOUND = 'User Not Found in RRCP Platform!';

export const BAD_REQUEST_MSG = 'Bad request, Please try again later.';

export const ATTACH_DOCUMENT_LABEL = 'Attach Document';

export const UPLOAD_FILE_SIZE =
	'You can upload up to 5 files, 50 MB max file size each.';
export const UPLOAD_FILE_FORMAT = 'Accepts .pdf';
export const maxFileSizeAllowedForChat = 50;
export const maxFileAllowedForActiveChatSession = 5;
export const maxFileSizeAllowedForRegInventoryComment = 10; // in MB

export const MAX_FILE_LIMIT_REACH_MESSAGE =
	'I can only process up to 5 files per session. Please attempt the upload again.';
export const DELETE_ALL_ATTACHMENTS_LABEL = 'Delete all attachments';
export const DELETE_ALL_ATTACHMENT_LABEL = 'Delete attachment';
export const UPLOAD_LABEL = 'Upload';
export const CANCEL_LABEL = 'Cancel';
export const TRIAL_EXPIRATION_TEXT = 'Your trial period has expired.';
export const FILE_SIZE_EXCEED_MSG = `The file exceeds ${maxFileSizeAllowedForChat} MB in size. Please verify that your file is no larger than ${maxFileSizeAllowedForChat}MB.`;
export const ACCEPTED_CHAT_FILE_TYPES = { 'application/pdf': ['.pdf'] };
export const FILE_TOO_LARGE = 'file-too-large';
export const TOO_MANY_FILES = 'too-many-files';
export const VIEW_MORE_LABEL = 'View more..';
export const VIEW_MORE_LIMIT = 3;
export const GENERATING_RESPONSE_LABEL = 'Generating Responses from ...';
export const DELETE_FILE_LABEL = 'Delete file';
export const DELETE_CONFIRMATION_LABEL = 'Are you sure you want to delete?';
export const DELETE_CONFIRMATION_UNDONE_LABEL =
	' file? This action cannot be undone.';
export const DELETE_FILE_SUCCESS_MESSAGE = 'File deleted successfully.';
export const ASSIGN_ROLES_LABEL = 'Assign Role';
export const USER_CONTACT_INFO = '0123456789';
export const USERS_LIMIT_AT_CREATE_LABEL =
	'Single user can be added at a once.';
export const ADD_USER_SERVICE_UNAVAILABLE_ERROR =
	"We're sorry, the 'Add User' service is currently unavailable. Please try again later.";
export const EXISTING_USER_EMAIL_ERROR_LABEL =
	'User with same email already present in the RRCP platform.';
export const USER_ID_INCLUDES_LABEL =
	'Username already present in the database';
export const USER_ID_SUCCESSFULLY_ADDED_LABEL =
	'The user has been successfully added to the group';
export const FOOTER_LABEL =
	'PwC. All rights reserved. PwC refers to the US member firm of the PwC network or one of its subsidiaries or affiliates.';
export const DEFAULT_TENANT_ID = 'pwc';
export const DEFAULT_API_VERSION = 'v2';
export const DOWNLOAD_FAILED_ERROR_LABEL = 'Failed to download.';
export const DOWNLOAD_SUCCESS_MESSAGE = 'Download successful.';
export const DOWNLOAD_PROGRESS = 'Download is in progress';
export const RESPONSE_SUBMITTED_TEXT = 'Response submitted';
export enum FEEDBACK_OBJECT_TYPE {
	HORIZON_OBLIGATION_SUMMARY = 'obligation-summary',
	RELATIONSHIP_MAPPING = 'relationship-mapping',
	REGULATION_INVENTORY_CHANGE_SUMMARY = 'change-summary',
	REGULATORY_SUMMARIZATION = 'regulatory-summarization',
	OBLIGATION_TO_POLICY_TYPE = 'obligation-to-policy',
	OBLIGATION_TO_POLICY_KEY_OBLIGATION = 'obligation-to-policy-key-obligation',
	PLAIN_ENGLISH_SUMMARY_TYPE = 'plain-english-summary',
	RISK_STATEMENT_TYPE = 'risk-statement',
	CONTROL_OBJECTIVE_TYPE = 'control-objective',
	CONTROL_STATEMENT_TYPE = 'control-statement',
	CONTROL_TEST_SCRIPTS_TYPE = 'control-test-scripts',
	CONTROL_QUALITY_GRAMMAR_CHECK_TYPE = 'control-quality-grammar-check',
	CONTROL_LANGUAGE_QUALITY_TYPE = 'language-quality-check',
	CONTROL_RECOMMENDATION_TYPE = 'control-recommendation',
}

export const EXPORT_EXCEL_NAME_DATE_FORMAT = 'MM-DD-YYYY-HH-mm-ss';

export enum EXPORT_FILE_TYPE {
	EXCEL = 'xlsx',
}

export enum ACTIVITY_TYPE {
	ACTIVITY = 'Activity',
	TODAY = 'Today',
	THIS_WEEK = 'This week',
	THIS_MONTH = 'This month',
	LAST_3_MONTH = 'Last 3 months',
	LAST_6_MONTH = 'Last 6 months',
	THIS_YEAR = 'This year',
	DATE_RANGE = 'Date range',
	CLEAR_ALL = 'Clear All',
}

export const NO_DATA_FOUND = 'No Data Found';
export const LOADING = 'Loading...';
export const CARD_SIZE_12 = 12;
export const TABLE_SIZE_10 = 10;
export const DYNAMIC_LIST_ITEM_SIZE = 45;
export const ALL_FIELDS_VALIDATION_ERROR =
	'( All Fields are required unless specified as optional/opt. )';
export const FIRST_NAME = 'First name';
export const LAST_NAME = 'Last name';
export const EMAIL = 'Enter email';
export const TENANT_VALIDATION_ERROR = 'is not a valid tenant';
export const mimeTypes = {
	csv: 'text/csv',
	xls: 'application/vnd.ms-excel',
	xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const CHOOSE_FILE_TYPE = 'Choose file type';
export const PDF_LABEL = 'pdf';
export const HTML_LABEL = 'html';
